import { getCookie } from '@/utils/cookie'

export const getBrowserEnv = () => {
  const ua = navigator.userAgent.toLowerCase()
  const THIRD_SOURCE = getCookie('third_source')
  switch (true) {
    case ua.match(/MicroMessenger/i) &&
      ua.match(/MicroMessenger/i)[0] === 'micromessenger':
      return 'weixin'
    case ua.match(/meicaiMallHarmony/i) &&
      ua.match(/meicaiMallHarmony/i)[0] === 'meicaiMallHarmony':
      return 'AppGallery Connect'
    case ua.match(/AlipayClient/i) &&
      ua.match(/AlipayClient/i)[0] === 'alipayclient':
      return 'koubei'
    case ua.match(/swan/i) && ua.match(/swan/i)[0] === 'swan':
      return 'baidu'
    case (ua.match(/Toutiao/i) &&
      ua.match(/Toutiao/i)[0] === 'toutiao' &&
      ua.match(/NewsArticle/i) &&
      ua.match(/NewsArticle/i)[0] === 'newsarticle') ||
      (ua.match(/news_article_lite/i) &&
        ua.match(/news_article_lite/i)[0] === 'news_article_lite'):
      return 'toutiao'
    case ua.match(/Toutiao/i) && ua.match(/Toutiao/i)[0] === 'toutiao':
      return 'douyin'
    case !!THIRD_SOURCE:
      // 业务原因，目前在第三方app处理方式一样，统一叫 thirdapp 即可，无需区分
      return 'thirdapp'
    default:
      return 'default'
  }
}
